"use client";

import { useTranslations } from "next-intl";
import { useState } from "react";

export function Faq() {
  const t = useTranslations();
  const faqs = t.raw("faqs") as { q: string; a: string }[];
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="border-t border-ink/[.08] bg-surface">
      <div className="mx-auto flex max-w-[1280px] flex-col gap-[clamp(32px,4vw,48px)] px-[clamp(20px,4vw,40px)] py-[clamp(72px,9vw,120px)]">
        <div data-reveal className="min-w-0">
          <p className="mb-[18px] text-xs uppercase tracking-[.2em] text-accent">
            {t("faqKicker")}
          </p>
          <h2 className="text-[clamp(28px,3.4vw,44px)] leading-[1.12]">
            {t("faqTitle")}
          </h2>
        </div>
        <div data-reveal className="min-w-0 max-w-[760px] border-t border-ink/[.14]">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="border-b border-ink/[.14]">
                <h3 className="m-0">
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="font-display flex w-full items-baseline justify-between gap-[22px] border-0 bg-none py-[22px] text-left text-[16.5px] font-medium leading-[1.45] text-ink transition-colors hover:text-accent"
                  >
                    <span className="min-w-0">{f.q}</span>
                    <span aria-hidden className="relative mt-1 h-3.5 w-3.5 flex-none">
                      <span className="absolute left-0 top-[6px] h-[1.5px] w-3.5 bg-accent" />
                      <span
                        className="absolute left-0 top-[6px] h-[1.5px] w-3.5 bg-accent transition-transform duration-300"
                        style={{ transform: isOpen ? "rotate(0deg)" : "rotate(90deg)" }}
                      />
                    </span>
                  </button>
                </h3>
                {isOpen ? (
                  <p className="-mt-1 pb-6 pr-11 text-[15px] leading-[1.72] font-light text-muted">
                    {f.a}
                  </p>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
